import { render, staticRenderFns } from "./PremiumBlockModal.vue?vue&type=template&id=5854eb40&scoped=true"
import script from "./PremiumBlockModal.vue?vue&type=script&lang=js"
export * from "./PremiumBlockModal.vue?vue&type=script&lang=js"
import style0 from "./PremiumBlockModal.vue?vue&type=style&index=0&id=5854eb40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5854eb40",
  null
  
)

export default component.exports